import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { Button } from 'antd';
import { Locale } from '../../../context/AppProvider';
import styles from './UsersContainer.module.scss';

interface DeleteUsersComponentProps {
  deleteUsers: () => void;
  selectedRowKeys: React.Key[];
  setSelectedRowKeys(selectedRowKeys: string[]): void;
}

const DeleteUsersComponent: React.FC<DeleteUsersComponentProps> = ({
  deleteUsers,
  selectedRowKeys,
  setSelectedRowKeys,
}) => {
  const intl = useIntl();
  const { messages } = React.useContext(Locale);
  return (
    <div className={styles.sharedContainer}>
      <Button
        type="default"
        danger
        onClick={() => {
          setSelectedRowKeys([]);
        }}
      >
        {messages['shared.cancel']}
      </Button>
      <Button
        icon={<DeleteOutlined />}
        onClick={deleteUsers}
        type="primary"
        data-testid="del-user-btn"
      >
        {intl.formatMessage(
          { id: 'users.filters.buttons.delete' },
          { num_users: selectedRowKeys.length }
        )}
      </Button>
    </div>
  );
};

export default DeleteUsersComponent;
